export const footerBrandName: string = 'LVBET.PL';
